import { getUrlPath } from './back-to-list-navigation.helper';

/**
 * AT-9152 pkt 4: kontekst listy, z ktorej odwiedzajacy przechodzi do podgladu.
 *
 * Wczesniej kazda lista trzymala jeden globalny wpis na typ bloku, wiec lista wystaw
 * osadzona w podgladzie pracy nadpisywala wpis strony listy wystaw i nawigacja
 * sasiadow czytala parametry zupelnie innej listy. Teraz wpisy sa kubelkowane po
 * sciezce strony, do ktorej lista nalezy.
 */
export const LIST_CONTEXT_STORAGE_KEY = 'listContextByPage';

export interface ListContextEntry {
  listUrl: string;
  listQueryParams: string;
}

export type ListContextStore = Record<string, Record<string, ListContextEntry>>;

export const parseListContextStore = (raw: string | null | undefined): ListContextStore => {
  if (!raw) {
    return {};
  }

  try {
    const parsed = JSON.parse(raw);

    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed as ListContextStore : {};
  } catch {
    return {};
  }
};

/**
 * Scala wpis listy z tym, co juz jest zapisane: adres znamy przy inicjalizacji listy,
 * a parametry zapytania dopiero przy pierwszym pobraniu danych.
 */
export const withListContextEntry = (
  store: ListContextStore,
  pageUrl: string,
  blockType: number | string,
  entry: Partial<ListContextEntry>,
): ListContextStore => {
  const pagePath = getUrlPath(pageUrl);
  const pageEntries = store[pagePath] || {};
  const current = pageEntries[blockType] || {listUrl: pagePath, listQueryParams: ''};

  return {
    ...store,
    [pagePath]: {
      ...pageEntries,
      [blockType]: {...current, ...entry},
    },
  };
};

/**
 * AT-8900: kontekst wolno zapisac tylko wtedy, gdy lista stoi na stronie aktualnie
 * wyswietlanej. Komponent listy potrafi dokonczyc inicjalizacje (albo zareagowac na
 * parametry adresu) juz po tym, jak router przestawil adres na podglad obiektu - wtedy
 * zapis kluczowany biezaca lokalizacja dopisywal na stronie podgladu wpis listy, ktorej
 * tam nie ma, z domyslnymi parametrami bloku zamiast parametrow widocznej listy.
 * Taki wpis przejmowal role zrodla dla nawigacji sasiadow (regula 1 w
 * `resolveNeighbourListSource`), wiec po pierwszym skoku Poprzedni/Nastepny chodzila
 * po nieodfiltrowanej liscie.
 */
export const isListOnCurrentPage = (
  listPageUrl: string | null | undefined,
  currentPageUrl: string | null | undefined,
): boolean => !!listPageUrl && !!currentPageUrl && getUrlPath(listPageUrl) === getUrlPath(currentPageUrl);

export const pickListContextEntry = (
  store: ListContextStore,
  pageUrl: string | null | undefined,
  blockType: number | string,
): ListContextEntry | null => {
  if (!pageUrl) {
    return null;
  }

  return store[getUrlPath(pageUrl)]?.[blockType] || null;
};
